import { BillableDeliveryNoteResponse } from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.dto'
import { StrictNullable } from '@/shared/types/app.types'
import { BillingModalInvoicesAddToGridDatasource } from '@/modules/billing-module/components/modal/invoices/add-to/config/billing-modal-invoices-add-to-grid.datasource'

export interface BillingModalInvoicesAddToParams {
    deliveryNotes: BillableDeliveryNoteResponse[]
}

export interface BillingModalInvoicesAddToState {
    datasource: StrictNullable<BillingModalInvoicesAddToGridDatasource>
}
export const initialBillingModalInvoicesAddToState =
    (): BillingModalInvoicesAddToState => ({
        datasource: null
    })
